import {resultSchema} from '../schema/result.schema';

export const PASSWORDRESETMUTATION = `mutation ($email: String!, $meta:RequestEntityMetaIn!) {
    passwordReset(email: $email, meta:$meta) {
    ${resultSchema}
    }
}`;